import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Benefits } from './Benefits';
import { LeadForm } from './LeadForm';
import { Trust } from './Trust';
import { Footer } from './Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans" data-id="element-35">
      <Hero data-id="element-36" />
      <PainPoints data-id="element-37" />
      <Benefits data-id="element-38" />
      <LeadForm data-id="element-39" />
      <Trust data-id="element-40" />
      <Footer data-id="element-41" />
    </div>;
}